var ctrlopt = ctrlopt,
  Pikaday = Pikaday,
  generic = generic || {},
  FB = FB || '',
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings || {};
  var oab = settings.oab || {};
  var time_interval = $('.appointments-container .date-picker').data('time-interval') || oab.time_interval || 0;
  var oab_date_override = oab.oab_override_date_format || 0;
  var oab_date_month_separator = oab.oab_date_month_separator || ' ';
  var start_day = oab.oab_datepicker_start_day || 0;
  var oab_date_format = settings.oab_date_format || 0;
  var oab_show_year_suffix = settings.oab_show_year_suffix || 0;
  var oab_show_month_after_year = settings.oab_show_month_after_year || 0;

  /* Concrete View */
  apptBook.AppointmentSelectSection = function (container) {
    apptBook.AppointmentSelectSection.superclass.constructor.call(this);
    this.id = 'appointments';
    this.jqBod = $('body');
    this.container = container;
    this.backTo = container.find('.js-back-to-link');
    this.apptContainer = container.find('.js-appointment-select');
    this.bookContainer = container.find('.book-appt-container');
    this.confContainer = container.find('.js-confirm-container');
    this.startOver = this.bookContainer.find('.js-start-over');
    this.selErrOverlay = container.find('.js-appt-book-services-overlay').remove();
    this.bookConflictOverlay = container.find('.js-appt-book-book-conflict-overlay').remove();
    this.artContainer = container.find('.artist-select-container');
    this.artSelect = this.artContainer.find('select.artist-select');
    this.calendarId = '0';
    this.appointmentId = null;
    this.appointmentTime = null;
    this.totalTime = 0;
    this.totalTimeWithPadding = 0;
    this.slotInterval = 0;
    this.serviceIds = [];
    this.stores = {};
    this.updateMode = false;
  };

  ctrlopt.extend(apptBook.AppointmentSelectSection, apptBook.AbstractSection);

  apptBook.AppointmentSelectSection.prototype.onUpdate = function (data) {
    var servs,
      servObj,
      hasCounter = false,
      hasCounters = false,
      me = this,
      aPgName = document.title + ' - Appointment Select & Book';

    this.serviceIds = [];
    this.totalTime = 0;
    this.totalTimeWithPadding = 0;
    this.updateMode = false;

    function runUpdate() {
      if (hasCounter && hasCounters) {
        me.getServicesInfo();
        me.buildArtists();
        if (!me.initialized) {
          me.buildApptSelect();
          me.initialized = true;
        } else {
          var date,
            dateSet = 0;

          if (me.appointmentTime) {
            date = dateUtils.convertTimeString(me.appointmentTime);
            dateSet = 1;
          } else if (me.calModel.selection) {
            date = me.calModel.selection;
            dateSet = 1;
          } else if (me.calModel.calData && me.calModel.calData.myDate) {
            date = me.calModel.calData.myDate;
            dateSet = 1;
          } else {
            date = new Date();
          }
          me.calModel.update({
            date: date,
            calendarId: me.calendarId,
            counterId: me.counterId,
            apptDur: me.totalTime,
            apptDurWithPadding: me.totalTimeWithPadding,
            timeSlotInterval: me.slotInterval,
            serviceIds: me.serviceIds,
            appointmentTime: me.appointmentTime,
            hilite: true,
            dateSet: dateSet,
            openTimes: me.counterData.opening_time_range
          });
          if (me.appointmentTime) {
            me.calModel.fire('time_selected', me.appointmentTime);
          } else {
            me.calModel.fire('time_deselected');
          }
        }
        me.buildBookAppt();
      }
    }

    function processUpdate() {
      if (data.params.appointmentId && !data.params.services) {
        return;
      }
      if (data.params.appointmentId && data.params.services) {
        me.model.getAppointment(
          data.params.appointmentId,
          function (apptData) {
            me.appointmentData = apptData;
            me.updateMode = true;
            me.counterId = me.appointmentData.counter_id;
            me.calendarId = me.appointmentData.calendar_id;
            me.servicesData = [];
            me.appointmentId = apptData.id;
            me.appointmentTime = apptData.start_time;
            servs = me.appointmentData.services;

            if (data.params.services) {
              servs = data.params.services;
            } else {
              servs = me.appointmentData.services;
            }

            for (var i = 0, len = servs.length; i < len; i += 1) {
              servObj = servs[i];
              me.servicesData.push({
                serviceId: servObj.id,
                serviceDuration: servObj.total_duration,
                serviceDurationWithPadding: servObj.total_duration_with_padding,
                serviceName: servObj.name,
                serviceDescription: servObj.description,
                servicePicture: servObj.picture,
                servicePrice: servObj.price
              });

              me.serviceIds.push(servObj.id);
            }

            me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
              me.counterData = data;
              hasCounter = true;
              me.slotInterval = me.counterData.timeslot_interval;
              runUpdate();
            });
          },
          function () {
            // If there is an error retrieving appointment id, go to beginning of APP
            var myUrl = [location.protocol, '//', location.host, location.pathname].join('');

            window.location = myUrl;
          }
        );
      } else {
        if (me.counterId !== data.params.counterId) {
          me.calendarId = '0';
        }
        if (data.params.updateMode) {
          me.updateMode = true;
          me.calendarId = '0';
        } else {
          me.updateMode = false;
        }
        me.counterId = data.params.counterId;
        me.appointmentTime = data.params.startTime;
        me.servicesData = data.params.services;
        for (var i = 0, len = me.servicesData.length; i < len; i += 1) {
          me.serviceIds.push(me.servicesData[i].serviceId);
        }

        me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
          me.counterData = data;
          hasCounter = true;
          runUpdate();
        });
      }

      if (typeof data.params.slotInterval != 'undefined') {
        me.slotInterval = data.params.slotInterval;
      }

      me.model.fetchCountersData({ service_id: this.serviceIds }, function (data) {
        me.countersData = data;
        hasCounters = true;
        runUpdate();
      });
    }

    if (data.sectionId === this.id) {
      generic.jsonrpc.fetch({
        method: 'user.json',
        params: [],
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          processUpdate();
        },
        onFailure: function () {
          me.userData = null;
          processUpdate();
        }
      });
    }
  };
  apptBook.AppointmentSelectSection.prototype.getServicesInfo = function () {
    this.totalTime = 0;
    this.totalTimeWithPadding = 0;
    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      var sData = this.servicesData[i];

      this.totalTime += parseInt(sData.serviceDuration);
      this.totalTimeWithPadding += parseInt(sData.serviceDurationWithPadding);
    }
  };
  apptBook.AppointmentSelectSection.prototype.buildApptSelect = function () {
    var mOptions,
      vOptions,
      dpOptions,
      calDate,
      calHead,
      timeSlotsContainer,
      timeSlotsTable,
      timeSlotRow,
      monthNames,
      dayNames,
      slotLabels,
      dpField,
      dpCalCont,
      dp,
      dpMonthNames,
      dpDayNames,
      CalHeadView,
      CalTimeSlotsView,
      CalDatePicker,
      dpYearSuffix,
      dpTrigger,
      me = this;

    timeSlotsContainer = this.apptContainer.find('.js-day-time-container');
    timeSlotsTable = timeSlotsContainer.find('.js-day-time-table');
    calHead = this.apptContainer.find('.js-calendar-head');
    timeSlotRow = timeSlotsTable.find('tr').first();
    slotLabels = timeSlotsTable.attr('data-time-slots').split(',');
    dp = this.apptContainer.find('.date-picker');
    dpField = this.apptContainer.find('#appt-book-date-picker-field');
    dpCalCont = this.apptContainer.find('#appt-book-date-picker-calendar-container');
    dpMonthNames = dp.attr('data-months').split(',');
    dpDayNames = dp.attr('data-days').split(',');
    dpYearSuffix = dp.attr('data-year-suffix');
    dpTrigger = calHead;
    CalHeadView = apptBook.CalendarHeader;
    CalTimeSlotsView = apptBook.CalendarTimeSlots;
    CalDatePicker = apptBook.CalDatePickerMobile;

    vOptions = {
      container: this.apptContainer,
      interval: this.slotInterval,
      timeSlotsContainer: timeSlotsContainer,
      timeSlotRow: timeSlotRow,
      monthNames: monthNames,
      dayNames: dayNames,
      slotLabels: slotLabels
    };

    dpOptions = {
      calContainer: dpCalCont,
      datepickerField: dpField,
      datepickerTrigger: dpTrigger,
      appointmentTime: this.appointmentTime,
      monthNames: dpMonthNames,
      dayNames: dpDayNames,
      yearSuffix: dpYearSuffix
    };

    mOptions = {
      dataModel: this.model,
      launchOverlayCallback: this.launchSelErrOverlay.bind(this),
      counterId: this.counterId,
      appointmentDuration: this.totalTime,
      appointmentDurationWithPadding: this.totalTimeWithPadding,
      serviceIds: this.serviceIds
    };

    this.calModel = new apptBook.CalendarModel();
    this.calModel.setData(mOptions);
    this.calTimeSlots = new CalTimeSlotsView(vOptions);
    this.calHeadView = new CalHeadView(calHead);
    this.calTimeSlots.setModel(this.calModel).startObserving();
    this.calHeadView.setModel(this.calModel).startObserving();

    this.datePicker = new CalDatePicker(dpOptions, this.calModel);
    this.datePicker.setModel(this.calModel);

    this.artSelect.on('change', function (e) {
      var calId = this.value,
        calName = this.options[this.selectedIndex].text;
      if (calId !== this.calendarId) {
        me.calModel.update({
          date: this.calDate,
          hilite: true,
          calendarId: calId,
          appointmentTime: this.appointmentTime,
          apptDur: this.totalTime,
          apptDurWithPadding: this.totalTimeWithPadding
        });
        me.calendarId = calId;
      }
    });

    calDate = this.appointmentTime ? this.calTimeSlots.convertTimeString(this.appointmentTime) : new Date();
    var openTimes = me.counterData.opening_time_range;

    this.calModel.update({
      date: calDate,
      hilite: true,
      calendarId: this.calendarId,
      appointmentTime: this.appointmentTime,
      openTimes: openTimes,
      showNextWeek: true
    });
  };

  apptBook.AppointmentSelectSection.prototype.buildBookAppt = function () {
    var me = this,
      bookBtn = this.confContainer.find('#appt-book-book-submit').off('click');

    this.startOver.off('click');
    this.startOver.click(function () {});

    this.backTo.off('click');
    this.backTo.click(backToPreviousStep);

    function backToPreviousStep(e) {
      e.preventDefault();
      var upObj = {};

      upObj = {
        sectionId: 'services',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          serviceIds: me.serviceIds,
          updateMode: true
        }
      };
      me.model.update(upObj);
    }

    this.calModel.on('time_selected', function () {
      bookBtn.removeClass('disabled');
    });

    this.calModel.on('time_deselected', function () {
      bookBtn.addClass('disabled');
    });

    $.each(['show', 'hide'], function (i, ev) {
      var el = $.fn[ev];

      $.fn[ev] = function () {
        this.trigger(ev);

        return el.apply(this, arguments);
      };
    });

    bookBtn.click(onSubmitBooking);

    function onSubmitBooking(e) {
      e.preventDefault();
      var params = {},
        updateData,
        $this = $(this);

      if ($this.hasClass('disabled')) {
        return;
      }

      $this.addClass('disabled');

      params = {
        counter_id: me.counterId,
        calendar_id: me.calendarId,
        appointment_service_id: me.serviceIds,
        services: me.servicesData,
        appointment_id: me.appointmentId,
        start_time: me.calModel.getSelection().selectionString
      };
      if (site.track && typeof site.track.evtView === 'function') {
        site.track.evtLink({
          event_name: 'appointmentBooking_DateTime',
          event_category: 'appointment booking',
          event_action: 'Date and Time Picked',
          event_label: me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + params.start_time
        });

        site.track.evtLink({
          event_name: 'appointmentBooking_bookNow',
          event_category: 'appointment booking',
          event_action: 'bookNow',
          event_label: me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + params.start_time
        });
      }

      updateData = {
        sectionId: 'next',
        params: params
      };

      function doBooking() {
        me.model.update(updateData);
        $this.addClass('disabled');
      }

      doBooking();
    }
  };

  apptBook.AppointmentSelectSection.prototype.launchSelErrOverlay = function () {
    var me = this;

    this.jqBod.prepend(this.selErrOverlay);
    this.selErrOverlay.show();
    this.selErrOverlay.off('click');
    this.selErrOverlay.click(function (e) {
      e.preventDefault();
      var upObj = {
        sectionId: 'previous',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          updateMode: me.updateMode
        }
      };

      me.model.update(upObj);
      me.selErrOverlay.off('click');
      me.selErrOverlay.remove();
    });
  };

  apptBook.AppointmentSelectSection.prototype.launchBookConflictOverlay = function () {
    var me = this,
      selDate = this.calModel.getSelection().selectionDate;

    this.jqBod.prepend(this.bookConflictOverlay);
    this.calModel.update({ date: selDate });
    this.bookConflictOverlay.show();
    this.bookConflictOverlay.click(function (e) {
      e.preventDefault();
      me.bookConflictOverlay.off('click');
      me.bookConflictOverlay.remove();
    });
  };

  /**
   * CalendarModel
   * This is the model. It controls the calendars state and main logic.
   * It broadcasts updates to registered views and controllers
   *
   */

  apptBook.CalendarModel = function () {
    apptBook.CalendarModel.superclass.constructor.call(this);
    this.dataSet = false;
  };

  // CalendarModel is a Publisher in a Publisher Subscriber (event listening) pattern.
  ctrlopt.extend(apptBook.CalendarModel, ctrlopt.Publisher);

  apptBook.CalendarModel.prototype.setData = function (options) {
    if (this.dataSet) {
      return;
    }
    this.dataSet = true;
    this.calData = {};
    this.dataModel = options.dataModel;
    this.launchOverlay = options.launchOverlayCallback;
    this.counterId = options.counterId;
    this.calendarId = 0;
    this.apptDur = options.appointmentDuration;
    this.apptDurWithPadding = options.appointmentDurationWithPadding;
    this.serviceIds = options.serviceIds;
  };

  apptBook.CalendarModel.prototype.update = function (data) {
    if (!this.dataSet || !data) {
      return;
    }
    var me = this;

    this.calData.hilite = data.hilite ? true : false;
    this.calData.apptDur = data.apptDur || this.apptDur;
    this.calData.apptDurWithPadding = data.apptDurWithPadding || this.apptDurWithPadding;
    this.calData.currentDate = new Date();
    this.calData.myDate = data.date || this.calData.myDate || this.calData.currentDate;
    this.calendarId = data.calendarId || this.calendarId;
    this.counterId = data.counterId || this.counterId;
    this.serviceIds = data.serviceIds || this.serviceIds;
    this.calData.apptTime = data.appointmentTime;
    this.calData.openTimes = data.openTimes || this.calData.openTimes;

    if (typeof data.apptDur != 'undefined') {
      this.apptDur = data.apptDur;
    }
    if (typeof data.apptDurWithPadding !== 'undefined') {
      this.apptDurWithPadding = data.apptDurWithPadding;
    }
    if (typeof data.timeSlotInterval != 'undefined') {
      this.calData.timeSlotInterval = data.timeSlotInterval;
    }

    this.dataModel.getCounter(this.counterId, { service_id: this.serviceIds }, function (countData) {
      var cal,
        cals = countData.calendars;

      if (!cals || !cals.length) {
        me.calData.timeslots = null;
        if (me.launchOverlay && typeof me.launchOverlay === 'function') {
          me.launchOverlay();
        }
      } else {
        for (var i = 0, len = cals.length; i < len; i += 1) {
          cal = cals[i];
          if (parseInt(cal.id, 10) === parseInt(me.calendarId, 10)) {
            me.calData.timeslots = cal.timeslots;
            break;
          }
        }
      }

      me.fire('time_deselected');
      me.dispatchUpdate(me.calData);
    });
  };

  apptBook.CalendarModel.prototype.dispatchUpdate = function (data) {
    this.fire('update', data);
  };

  apptBook.CalendarModel.prototype.getData = function () {
    return this.dataSet ? this.calData : null;
  };

  apptBook.CalendarModel.prototype.setSelection = function (selection) {
    this.selection = selection;
    this.selectionString =
      selection.getFullYear() +
      '-' +
      (selection.getMonth() + 1) +
      '-' +
      selection.getDate() +
      ' ' +
      selection.getHours() +
      (time_interval ? ':' + ('0' + selection.getMinutes()).slice(-2) + ':00' : ':00:00');

    this.fire('time_selected', this.selectionString);
  };

  apptBook.CalendarModel.prototype.getSelection = function () {
    return {
      selectionDate: this.selection,
      selectionString: this.selectionString
    };
  };

  /**
   * CalDatePicker is a class faor a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePicker = function (options) {
    apptBook.CalDatePicker.superclass.constructor.call(this);
    var me = this,
      $bod = options.jqBod,
      overlay = options.overlay,
      closeBtn = options.closeBtn,
      calContainer = options.calContainer,
      dpField = options.datepickerField,
      dpTrigger = options.datepickerTrigger,
      days = options.dayNames,
      months = options.monthNames,
      year_suffix = options.yearSuffix,
      pikaday = new Pikaday({
        field: dpField[0],
        firstDay: parseInt(start_day),
        minDate: new Date(),
        maxDate: new Date(2050, 12, 31),
        yearRange: [2000, 2050],
        showMonthAfterYear: oab_show_month_after_year ? true : false,
        yearSuffix: oab_show_year_suffix ? year_suffix : '',
        bound: false,
        container: calContainer[0],
        numberOfMonths: 2,
        onSelect: onDateSelect,
        i18n: {
          months: months,
          weekdays: days,
          weekdaysShort: days
        }
      });

    $bod.prepend(overlay);

    function openOverlay() {
      overlay.css('display', 'block');
      pikaday.gotoDate(new Date());
    }

    function closeOverlay() {
      overlay.css('display', 'none');
    }

    function onDateSelect() {
      var d = pikaday.getDate();

      if (me.model) {
        me.model.update({
          date: d,
          hilite: true
        });
      }
      closeOverlay();
    }

    dpTrigger.click(openOverlay);
    closeBtn.click(closeOverlay);
  };

  ctrlopt.extend(apptBook.CalDatePicker, ctrlopt.mvc.AbstractController);

  /* Desktop/Mobile Appointment Select */

  /* Desktop/Mobile Date Picker - Date Picker */

  /**
   * CalDatePickerMobile is a sub-class of CalDatePicker. It is a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePickerMobile = function (options, calModelObj) {
    apptBook.CalDatePickerMobile.superclass.constructor.call(this);
    var me = this,
      calContainer = options.calContainer,
      dpField = options.datepickerField,
      dpTrigger = options.datepickerTrigger,
      days = options.dayNames,
      months = options.monthNames,
      year_suffix = options.yearSuffix,
      default_date,
      timeSlotData;
    var pikadayOptions = {
      field: dpField[0],
      firstDay: parseInt(start_day),
      minDate: new Date(),
      maxDate: new Date(2050, 12, 31),
      yearRange: [2000, 2050],
      showMonthAfterYear: oab_show_month_after_year ? true : false,
      yearSuffix: oab_show_year_suffix ? year_suffix : '',
      bound: false,
      container: calContainer[0],
      onSelect: onDateSelect,
      disableDayFn: disableDate,
      i18n: {
        months: months,
        weekdays: days,
        weekdaysShort: days
      }
    };

    if (options.appointmentTime) {
      default_date = dateUtils.convertTimeString(options.appointmentTime);
    } else {
      if (!calModelObj || !calModelObj.calData.timeslots) {
        var countersData = calModelObj.dataModel.countersData;

        for (var i = 0; i < countersData.length; i++) {
          if (countersData[i].id === calModelObj.counterId) {
            if (calModelObj.calendarId === 0) {
              timeSlotData = countersData[i].calendars[0].timeslots;
            }
            break;
          }
        }
      } else {
        timeSlotData = calModelObj.calData.timeslots;
      }
      if (timeSlotData && timeSlotData.length) {
        default_date = new Date(timeSlotData[0].start_date);
      }
      pikadayOptions.onDraw = onDateSelect;
    }
    if (default_date) {
      pikadayOptions.defaultDate = default_date;
      pikadayOptions.setDefaultDate = true;
    }
    var pikaday = new Pikaday(pikadayOptions);

    function disableDate(date) {
      var calendarModelObj = me.model;

      if (!calendarModelObj) {
        calendarModelObj = calModelObj;
      }
      // build key from date values
      var dateKey = dateUtils.dateToString(date, 'yyyy-mm-dd');
      // use that key to look up store-open times for that day
      var openTimes = calendarModelObj.calData.openTimes;
      var datesInvalid = calendarModelObj.calData.datesInvalid;
      var timeSlotData,
        dateTimeSlots,
        i,
        start,
        end,
        availableTime,
        availableTimeMins,
        totalEnabledTimeSections = 0;

      if (
        !calendarModelObj.calData ||
        (Object.keys(calendarModelObj.calData).length === 0 && calendarModelObj.calData.constructor === Object)
      ) {
        var countersData = calendarModelObj.dataModel.countersData;

        for (i = 0; i < countersData.length; i++) {
          if (countersData[i].id === calendarModelObj.counterId) {
            if (calendarModelObj.calendarId === 0) {
              timeSlotData = countersData[i].calendars[0].timeslots;
            }
            break;
          }
        }
      } else {
        timeSlotData = calendarModelObj.calData.timeslots;
      }
      if (timeSlotData) {
        dateTimeSlots = timeSlotData.filter(function (el) {
          // adding polyfill for "startsWith" to run in IE 11
          if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (searchString, position) {
              return this.substr(position || 0, searchString.length) === searchString;
            };
          }

          return el.start_date.startsWith(dateKey);
        });
        if (!dateTimeSlots.length) {
          return date;
        }
        for (i = 0; i < dateTimeSlots.length; i++) {
          start = dateUtils.convertTimeString(dateTimeSlots[i].start_date);
          end = dateUtils.convertTimeString(dateTimeSlots[i].end_date);
          availableTime = Math.abs(end - start);
          availableTimeMins = Math.floor(availableTime / 60000);
          if (availableTimeMins >= time_interval) {
            totalEnabledTimeSections++;
          }
        }
      }
      if (totalEnabledTimeSections === 0) {
        return date;
      }
      // openTimes only covers a narrow near-term window; a missing date just
      // means it's outside that window, not that the store is closed. Only
      // disable when openTimes explicitly has an empty entry for the date.
      if (openTimes && typeof openTimes[dateKey] !== 'undefined' && !openTimes[dateKey].length) {
        return date;
      }
      if (datesInvalid && $.inArray(dateKey, datesInvalid) >= 0) {
        return date;
      }
    }
    function showCalendarContent() {
      var timeSlotData, currentAvailableDateSlot, activeTimeSlot, selectedDate, calendarModelObj;

      calContainer.show();
      calendarModelObj = me.model && me.model.calData.timeslots ? me.model : calModelObj;
      if (!calendarModelObj || !calendarModelObj.calData.timeslots) {
        return;
      }
      timeSlotData = calendarModelObj.calData.timeslots;

      pikaday.gotoDate(new Date());
      if (timeSlotData.length) {
        currentAvailableDateSlot = timeSlotData[0].start_date;
        activeTimeSlot = currentAvailableDateSlot.split(/[- :]/);
        selectedDate = currentAvailableDateSlot.replace(/-/g, '/');
        calContainer.find('td').removeClass('is-selected');
        calContainer.find('td[data-day=' + Number(activeTimeSlot[2]) + ']').addClass('is-selected');
        me.model.update({
          date: new Date(selectedDate),
          apptDur: me.model.calData.apptDur,
          apptDurWithPadding: me.model.calData.apptDurWithPadding
        });
      }
    }
    function onDateSelect() {
      var d = pikaday.getDate();

      if (me.model) {
        me.model.update({
          date: d,
          hilite: true
        });
      }
    }

    dpTrigger.click(showCalendarContent);
  };

  ctrlopt.extend(apptBook.CalDatePickerMobile, ctrlopt.mvc.AbstractController);

  /* End Desktop/Mobile Date Picker */

  /* Desktop/Mobile Calendar Header */

  /**
   * CalendarHeader is a sub-class of CalendarHeader. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeader = function (header) {
    apptBook.CalendarHeader.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.headCopy = this.header.html();
    this.months = this.header.attr('data-months').split(',');
  };

  ctrlopt.extend(apptBook.CalendarHeader, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeader.prototype.onUpdate = function (data) {
    this.calData = data;
    var headOut,
      myDate = this.calData.myDate;

    if (oab_date_override) {
      headOut = this.headCopy + ' ' + myDate.getDate() + oab_date_month_separator + this.months[myDate.getMonth()];
    } else if (oab_date_format) {
      headOut =
        this.months[myDate.getMonth()] +
        ' ' +
        myDate.getDate() +
        this.header.attr('data-day-suffix') +
        ' ' +
        this.headCopy;
    } else {
      headOut = this.headCopy + ' ' + this.months[myDate.getMonth()] + ' ' + myDate.getDate();
    }
    this.header.html(headOut);
  };

  /*
   * CalendarHeader is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Calendar Time Slot Selector.
   *
   *
   * @param thisDate Date required
   * @param openTimes Object required
   * @returns Object example: { morning: true, afternoon: false, evening: true }
   */
  apptBook.CalendarHeader.prototype.getStoreOpenStates = function (thisDate, openTimes) {
    var returnObj = {
      morning: false,
      afternoon: false,
      evening: false
    };
    var startMorningStr = '10:00';
    var endMorningStr = '11:45';
    var startAfternoonStr = '12:00';
    var endAfternoonStr = '16:45';
    var startEveningStr = '17:00';
    var endEveningStr = '22:00';
    var mergeDateTime = function (thisDate, timeStr) {
      var returnDate = new Date(thisDate);

      returnDate.setHours(timeStr.split(':')[0]);
      returnDate.setMinutes(timeStr.split(':')[1]);

      return returnDate;
    };
    var startMorningDate = mergeDateTime(thisDate, startMorningStr);
    var endMorningDate = mergeDateTime(thisDate, endMorningStr);
    var startAfternoonDate = mergeDateTime(thisDate, startAfternoonStr);
    var endAfternoonDate = mergeDateTime(thisDate, endAfternoonStr);
    var startEveningDate = mergeDateTime(thisDate, startEveningStr);
    var endEveningDate = mergeDateTime(thisDate, endEveningStr);
    var dayPartRanges = {
      morning: [startMorningDate, endMorningDate],
      afternoon: [startAfternoonDate, endAfternoonDate],
      evening: [startEveningDate, endEveningDate]
    };
    var openTimesDateKey = dateUtils.dateToString(thisDate, 'yyyy-mm-dd');

    if (!openTimes[openTimesDateKey]) {
      return returnObj;
    }
    // iterate over open sessions for that day
    for (var i = 0, len = openTimes[openTimesDateKey].length; i < len; i++) {
      // munge date strings to work with conversion method
      var startOpenStr = openTimesDateKey + ' ' + openTimes[openTimesDateKey][i]['start_time'] + ':00';
      var endOpenStr = openTimesDateKey + ' ' + openTimes[openTimesDateKey][i]['end_time'] + ':00';
      // get Date objects for the open & close times
      var startOpenDate = dateUtils.convertTimeString(startOpenStr);
      var endOpenDate = dateUtils.convertTimeString(endOpenStr);
      // create an array to represent this "open time" range
      var openRange = [startOpenDate, endOpenDate];

      // iterate over day parts
      for (var dayPart in dayPartRanges) {
        // if we've already found an open time for this day part, skip to next day part
        if (!!returnObj[dayPart]) {
          continue;
        }
        // if they overlap, set return value to true for this day part
        if (dateUtils.compareRanges(dayPartRanges[dayPart], openRange)) {
          returnObj[dayPart] = true;
          // skip to next day part
          continue;
        }
      } // end iterate over day parts
    } // end iterate over open sessions

    return returnObj;
  };
  /* End Desktop/Mobile Calendar Header */

  /* Desktop/Mobile Time Slot Select */
  /*
   * CalendarTimeSlots is a class for concrete view of the CalendarModel.
   * It displays and manages the display logic for the Desktop/Mobile Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */
  apptBook.CalendarTimeSlots = function (options) {
    apptBook.CalendarTimeSlots.superclass.constructor.call(this, options);
    this.initialized = false;
    this.container = options.container;
    this.colHeads = options.colHeads;
    this.timeSlotRow = options.timeSlotRow;
    this.timeSlotInterval = options.interval;
    this.timeContainer = options.timeContainer;
    this.timeSlotsContainer = options.timeSlotsContainer;
    this.days = options.dayNames;
    this.months = options.monthNames;
    this.slotLabels = options.slotLabels;

    this.slots = [];
    var start_hour_time = this.container.attr('data-cal-start-hour') || 7;
    var end_hour_time = this.container.attr('data-cal-end-hour') || 22;
    var time_difference = end_hour_time - start_hour_time;

    for (var i = 0; i <= time_difference; i++) {
      if (time_interval) {
        for (var j = 0, k = 0; j < 60; k++) {
          this.slots.push({ hour: parseInt(start_hour_time) + i + ':' + k * time_interval });
          j = parseInt(j) + parseInt(time_interval);
        }
      } else {
        this.slots.push({ hour: parseInt(start_hour_time) + i });
      }
    }
    for (var m = 0, len = this.slots.length; m < len; m += 1) {
      if (this.slotLabels && this.slotLabels[m]) {
        this.slots[m].label = this.slotLabels[m];
      } else {
        this.slots[m].label = '&nbsp;';
      }
    }
  };

  ctrlopt.extend(apptBook.CalendarTimeSlots, ctrlopt.mvc.AbstractView);

  apptBook.CalendarTimeSlots.prototype.defaultController = function () {
    return null;
  };

  apptBook.CalendarTimeSlots.prototype.onUpdate = function (data) {
    this.calData = data;
    this.buildWeekView();
  };
  apptBook.CalendarTimeSlots.prototype.setCellDateTimes = function () {
    var $tds = this.tdElems;
    var myDateTime = new Date(this.calData.myDate);

    $tds.each(function () {
      var $td = $(this);
      var parts = $td.data('hour').split(':');

      myDateTime.setHours(parts[0], parts[1], 0, 0);
      $td.attr('data-date-time', myDateTime);
    });
  };
  apptBook.CalendarTimeSlots.prototype.buildWeekView = function () {
    var hour,
      sText,
      row,
      tds,
      tdElem,
      td,
      startSlot,
      endSlot,
      myDateKey,
      startSlotKey,
      endSlotKey,
      myDate = this.calData.myDate,
      timeslots = this.calData.timeslots;
    var startViAfternoon, endViAfternoon, startViEvening;
    var rowsTable = [];
    var timeSlotsTable = this.timeSlotsContainer.find('.js-day-time-table');
    var timeMorningSlotTable = this.timeSlotsContainer.find('.js-day-time-table-morning');
    var timeAfternoonSlotTable = this.timeSlotsContainer.find('.js-day-time-table-afternoon');
    var timeEveningSlotTable = this.timeSlotsContainer.find('.js-day-time-table-evening');

    if (!timeslots) {
      return;
    }
    startViAfternoon = timeSlotsTable.attr('data-time-afternoon-range').split('-')[0];
    endViAfternoon = timeSlotsTable.attr('data-time-afternoon-range').split('-')[1];
    startViEvening = timeSlotsTable.attr('data-time-evening-range').split('-')[0];

    tds = this.timeSlotRow.find('td');
    tdElem = tds.first();

    timeMorningSlotTable.empty();
    timeAfternoonSlotTable.empty();
    timeEveningSlotTable.empty();

    // Verify if the my date selected exists in the timeslot
    startSlot = timeslots[0].start_date;
    endSlot = timeslots[timeslots.length - 1].end_date;
    myDateKey = dateUtils.dateToString(myDate, 'yyyy-mm-dd');
    startSlotKey = startSlot.split(' ')[0];
    endSlotKey = endSlot.split(' ')[0];

    if (dateUtils.inRange(myDateKey, startSlotKey, endSlotKey)) {
      for (var i = 0; i < this.slots.length; i += 1) {
        var hourVal = 0;

        sText = this.slots[i].label;
        hour = this.slots[i].hour;
        row = this.timeSlotRow.clone();
        row.empty();
        hourVal = parseInt(hour.split(':')[0]);
        td = tdElem.clone();
        td.text(sText);
        td.attr('data-hour', hour);
        td.addClass('date-time-hours');
        row.append(td);
        if (hourVal >= parseInt(startViAfternoon.split(':')[0]) && hourVal <= parseInt(endViAfternoon.split(':')[0])) {
          timeAfternoonSlotTable.append(row);
          rowsTable.push({ afternoon: hour });
        } else if (hourVal >= parseInt(startViEvening.split(':')[0])) {
          timeEveningSlotTable.append(row);
          rowsTable.push({ evening: hour });
        } else {
          timeMorningSlotTable.append(row);
          rowsTable.push({ morning: hour });
        }
      }

      if (typeof this.calData.timeSlotInterval != 'undefined') {
        this.timeSlotInterval = this.calData.timeSlotInterval;
      }
      this.tdElems = this.timeSlotsContainer.find('td.date-time-hours');

      this.setCellDateTimes();
      this.setSlots();
      this.resetSlotsAvalaible();
      if (this.calData.apptTime) {
        this.setApptTime();
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.processSlot = function (start, end, interval) {
    var startIndex = 0,
      intervalFactor = 1,
      intervalV = interval ? interval : 60,
      dMinute = Math.ceil(start.getMinutes() / intervalV),
      startHour = dMinute * intervalV === 60 ? start.getHours() + 1 : start.getHours(),
      startMin = dMinute * intervalV === 0 || dMinute * intervalV === 60 ? '00' : dMinute * intervalV,
      startTime = parseInt(startHour).toString() + ':' + parseInt(startMin).toString(),
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this;

    for (var j = 0; j < len; j += intervalFactor) {
      if (this.slots[j].hour === startTime) {
        startIndex = j;
        break;
      }
    }

    for (var i = startIndex; i < len; i += intervalFactor) {
      var timeLeft,
        minLeft,
        sT = this.slots[i].hour.split(':');

      sHrDate.setHours(sT[0], sT[1], 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < this.calData.apptDurWithPadding) {
        break;
      } else {
        this.tdElems
          .eq(i)
          .addClass('enabled')
          .click(function () {
            var slotDate = new Date(start.getTime()),
              $this = $(this);

            me.tdElems.removeClass('selected');
            $(this).addClass('selected');
            slotDate.setHours(parseInt($this.attr('data-hour'), 10));
            if (time_interval) {
              slotDate.setMinutes(parseInt($this.attr('data-hour').split(':')[1]));
            }
            me.model.setSelection(slotDate);
          });
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.setSlots = function () {
    var timeslots = this.calData.timeslots,
      myDate = new Date(this.calData.myDate.getTime());

    myDate.setHours(0, 0, 0, 0);
    this.tdElems.removeClass('enabled').off('click');

    if (!timeslots) {
      return;
    }
    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = this.convertTimeString(timeslots[i].start_date),
        end = this.convertTimeString(timeslots[i].end_date),
        startDay = new Date(start.getTime());

      startDay.setHours(0, 0, 0, 0);

      if (startDay.getTime() === myDate.getTime()) {
        this.processSlot(start, end, time_interval);
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.resetSlotsAvalaible = function () {
    this.tdElems.each(function () {
      var $td = $(this);

      if (!$td.hasClass('enabled')) {
        $td.closest('tr').remove();
      }
    });
  };

  apptBook.CalendarTimeSlots.prototype.setApptTime = function () {
    var me = this,
      myDate = new Date(this.calData.myDate.getTime()),
      apptDate = this.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHourMin = parseInt(apptDate.getHours()).toString() + ':' + parseInt(apptDate.getMinutes()).toString();

    if (apptTime === myDate.getTime()) {
      this.timeSlotsContainer.find('td.date-time-hours').each(function () {
        var $this = $(this),
          tdHour = $this.data('hour');

        if (tdHour === apptHourMin) {
          $this.addClass('selected').addClass('enabled');
          me.model.setSelection(apptDate);
        }
      });
    }
  };

  apptBook.CalendarTimeSlots.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };

  /* End Desktop/Mobile Time Slot Select */

  apptBook.AppointmentSelectSection.prototype.buildArtists = function () {
    var me = this,
      calData = this.counterData.calendars;
    this.artSelect.find('option').remove();
    if (!calData || !calData.length) {
      this.launchSelErrOverlay();
    } else if (calData.length > 1) {
      this.artContainer.removeClass('hidden');
      for (var i = 0, len = calData.length; i < len; i += 1) {
        var optionText = calData[i].public_name,
          optionValue = calData[i].id,
          optionDisplay =
            typeof calData[i].artist_selectable_online !== 'undefined'
              ? parseInt(calData[i].artist_selectable_online)
              : 1,
          isChairMode = typeof calData[i].chair_mode !== 'undefined' ? parseInt(calData[i].chair_mode) : 1,
          newOption;
        if (optionDisplay && !isChairMode) {
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>');
          if (optionValue === this.calendarId) {
            newOption.attr('selected', 'selected');
          }
          this.artSelect.append(newOption);
        }
      }
      var artSelectLength = this.artSelect.find('option');
      if (artSelectLength.length > 1) {
        this.artContainer.removeClass('hidden');
      }
      me.container.find('.selectbox').each(function () {
        $(this).trigger('select.enabled');
      });
    }
  };

  var dateUtils = {
    // Source: http://stackoverflow.com/questions/497790
    // That's right, I copied it from Stack Overflow.
    convert: function (d) {
      // Converts the date in d to a date-object. The input can be:
      //   a date object: returned without modification
      //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
      //   a number     : Interpreted as number of milliseconds
      //                  since 1 Jan 1970 (a timestamp)
      //   a string     : Any format supported by the javascript engine, like
      //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
      //  an object     : Interpreted as an object with year, month and date
      //                  attributes.  **NOTE** month is 0-11.
      return d.constructor === Date
        ? d
        : d.constructor === Array
        ? new Date(d[0], d[1], d[2])
        : d.constructor === Number
        ? new Date(d)
        : d.constructor === String
        ? new Date(d)
        : typeof d === 'object'
        ? new Date(d.year, d.month, d.date)
        : NaN;
    },
    compare: function (a, b) {
      // Compare two dates (could be of any type supported by the convert
      // function above) and returns:
      //  -1 : if a < b
      //   0 : if a = b
      //   1 : if a > b
      // NaN : if a or b is an illegal date
      // NOTE: The code inside isFinite does an assignment (=).
      return isFinite((a = this.convert(a).valueOf())) && isFinite((b = this.convert(b).valueOf()))
        ? (a > b) - (a < b)
        : NaN;
    },
    inRange: function (d, start, end) {
      // Checks if date in d is between dates in start and end.
      // Returns a boolean or NaN:
      //    true  : if d is between start and end (inclusive)
      //    false : if d is before start or after end
      //    NaN   : if one or more of the dates is illegal.
      // NOTE: The code inside isFinite does an assignment (=).
      return isFinite((d = this.convert(d).valueOf())) &&
        isFinite((start = this.convert(start).valueOf())) &&
        isFinite((end = this.convert(end).valueOf()))
        ? start <= d && d <= end
        : NaN;
    },
    dateToString: function (date, format) {
      var str = date.toLocaleString();

      switch (format) {
        case 'yyyy-mm-dd':
          var thisMonthString = date.getMonth() + 1;

          thisMonthString = thisMonthString < 10 ? '0' + thisMonthString : '' + thisMonthString;
          var thisDateString = date.getDate();

          thisDateString = thisDateString < 10 ? '0' + thisDateString : '' + thisDateString;
          str = date.getFullYear() + '-';
          str += thisMonthString + '-';
          str += thisDateString;
          break;
        default:
          break;
      }

      return str;
    },
    // tests 2 date ranges for overlap
    // @param r1 Array required [start date, end date]
    // @param r2 Array required [start date, end date]
    compareRanges: function (r1, r2) {
      if (r2[0] > r1[1]) {
        return false;
      }
      if (r2[1] < r1[0]) {
        return false;
      }

      return true;
    },
    //
    // converts string to date object, from format "yyyy-mm-dd hh:MM" ONLY
    convertTimeString: function (tString) {
      var split, dateArray, timeArray, y, m, d, hr, min, sec;

      split = tString.split(' ');
      dateArray = split[0].split('-');
      timeArray = split[1].split(':');

      y = parseInt(dateArray[0], 10);
      m = parseInt(dateArray[1], 10) - 1;
      d = parseInt(dateArray[2], 10);
      hr = parseInt(timeArray[0], 10);
      min = parseInt(timeArray[1], 10);
      sec = parseInt(timeArray[2], 10);

      return new Date(y, m, d, hr, min, sec);
    }
  }; // end dateUtils

  Drupal.appointmentBooking.dateUtils = dateUtils;

  Drupal.behaviors.apptBookScheduleFormatter_V2 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var self = this;
      var $scheduleContainer = $('#appointments', context);
      var view = new apptBook.AppointmentSelectSection($scheduleContainer);

      view.setModel(apptBook.sectionModel).startObserving();
      $('.artist-info', context).on('click', function () {
        $.colorbox.remove();
        var artist_node = $('#appointments', context).attr('data-artist-node');
        $.ajax({
          url: 'https://' + window.location.host + '/elc_api/' + artist_node + '/',
          type: 'GET',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Accept', 'HTML');
          },
          success: function (data) {
            var content =
              '<div class="app-artist-info">' +
              $('#' + artist_node.replace('/', '-') + ' .content', data.rendered).html() +
              '</div>';
            var artistDescLimit = 200;
            var colorboxSettings = {
              html: content,
              close: '<i class="icon--remove"></i>',
              className: 'appt-artist-overlay',
              width: '60%',
              transition: 'none',
              opacity: '0.7',
              onComplete: function () {
                var cboxContent = $('#cboxContent');
                $('#cboxLoadedContent', cboxContent).css({ width: '103%', height: '410px' });
                $('.app-artist-info', cboxContent).slick({
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  variableWidth: true,
                  infinite: false,
                  responsive: [
                    {
                      breakpoint: 640,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                        centerMode: true
                      }
                    }
                  ]
                });
                $('.artist-description', cboxContent).each(function () {
                  var artistFullDesc = $(this).text();
                  if (artistFullDesc.length > artistDescLimit) {
                    var firstSet = artistFullDesc.substring(0, artistDescLimit);
                    var secondHalf = artistFullDesc.substring(artistDescLimit, artistFullDesc.length);
                    $(this).empty().html(firstSet);
                    $(this).append('<a href="javascript:void(0);" class="read-more">...</a>');
                    $(this).append('<span class="more-text hidden">' + secondHalf + '</span>');
                  }
                });
                $('.read-more', cboxContent).click(function () {
                  $('.app-artist-info .slick-next', cboxContent).css({ right: '15px' });
                  $(this).parent().find('.more-text').removeClass('hidden');
                  $(this).parent().find('.read-more').addClass('hidden');
                });
                $('.slick-dots li button, .slick-prev, .slick-next', cboxContent).click(function () {
                  $('.app-artist-info .slick-next', cboxContent).css({ right: '25px' });
                  $('.artist-description', cboxContent).each(function () {
                    $(this).find('.more-text').addClass('hidden');
                    $(this).find('.read-more').removeClass('hidden');
                  });
                });
              }
            };
            var colorboxPcSettings = { width: '680px', height: '410px' };
            var colorboxMobileSettings = { width: '90%', height: '420px' };
            var overlay = $.extend(
              {},
              colorboxSettings,
              +site.client.isMobile ? colorboxMobileSettings : colorboxPcSettings
            );
            self.openWindow(overlay);
          }
        });
      });
    },
    openWindow: function (overlay) {
      $.colorbox(overlay);
    },
    attached: false
  };
})(jQuery);
